import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { getCurrentPath } from 'src/helpers/browser'
import { Panel, If } from 'src/Components'
import QuestionSingle from 'src/Components/homeowners/Questions/Single'
import {
  OverlayPanel,
  OverlayQuestionsFooter
} from 'src/Components/shared/Routing'
import Page from 'src/Components/shared/Routing/Page'
import history from 'src/history'

import styles from './GemGrid.module.scss'

const propTypes = {
  className: PropTypes.string,
  horizontal: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      calculation: PropTypes.function,
      key: PropTypes.string.isRequired,
      amount: PropTypes.number,
      title: PropTypes.node,
      icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
      content: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
    })
  ),
  question: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }),
  topic: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }),
  collapsed: PropTypes.bool,
  disableCospoMessage: PropTypes.bool,
  overlayPanelName: PropTypes.string,
  overlayPanelFrom: PropTypes.string,
  overlayPanelTitle: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.element
  ])
}

const defaultProps = {
  disableCospoMessage: false
}

const GemGrid = ({
  className,
  horizontal,
  data,
  disableCospoMessage,
  collapsed,
  question,
  topic,
  overlayPanelName,
  overlayPanelFrom,
  overlayPanelTitle,
  children
}) => (
  <div
    className={classnames(
      styles.container,
      collapsed && styles.collapsed,
      horizontal && styles.horizontal
    )}
  >
    <OverlayPanel
      back={overlayPanelFrom}
      path={`${overlayPanelFrom}/${overlayPanelName}`}
      anchorOffset={125}
      title={overlayPanelTitle}
      render={({ match, history }) => {
        const gemPages = data.map((Gem, index) => (
          <Page
            key={Gem.key}
            path={`${match.url}/${Gem.key.toLowerCase()}`}
            navigation={{
              swipeEnabled: true,
              onPrev: () => {
                const prevIndex = (data.length + index - 1) % data.length
                gemPageNav(data[prevIndex], match, history)
              },
              onNext: () => {
                const nextIndex = (index + 1) % data.length
                gemPageNav(data[nextIndex], match, history)
              }
            }}
            render={() => (
              <>
                <Page.Carousel
                  indicateIndex={index}
                  indicateTotal={data.length}
                >
                  <Gem.Gem inCarousel />
                </Page.Carousel>
                <Page.Body>
                  <Gem.Detail close={() => history.push(overlayPanelFrom)} />
                </Page.Body>
              </>
            )}
          />
        ))
        const pageGem = data.find(Gem =>
          getCurrentPath().endsWith(Gem.key.toLowerCase())
        )
        const footer = (
          <Page.Footer showDisclaimer key='gem_panel_footer'>
            <OverlayQuestionsFooter
              topic={pageGem ? pageGem.topic : topic}
              questions={
                pageGem ? pageGem.questions || [pageGem.question] : [question]
              }
              placeholder
              disableCospoMessage={disableCospoMessage}
            />
          </Page.Footer>
        )

        return [...gemPages, footer]
      }}
    />

    <div className={classnames(className, styles.gemGrid)}>
      {data.map((Gem, i) => (
        <Gem.Gem
          horizontal={horizontal}
          key={Gem.key}
          onClick={() => {
            if (overlayPanelName && overlayPanelFrom) {
              history.push(
                `${getCurrentPath()}/${overlayPanelName}/${Gem.key.toLowerCase()}`
              )
            }
          }}
        />
      ))}
    </div>
    <If condition={question && topic}>
      <Panel.Footer>
        <QuestionSingle
          disableCospo={disableCospoMessage}
          question={question}
          topic={topic}
        />
      </Panel.Footer>
    </If>
  </div>
)

const gemPageNav = (Gem, match, history) =>
  history.replace(`${match.url}/${Gem.key.toLowerCase()}`)

GemGrid.propTypes = propTypes
GemGrid.defaultProps = defaultProps
export default GemGrid
